const route = {
  path: 'hospital-manage',
  name: '机构管理',
  component: {
    render: e => e('router-view')
  },
  children: [
    {path: 'hospital-dept-set', name: '机构和部门', component: () => import('../views/deptManage/hospitalAndDept.vue')},
    {path: 'staff-manage', name: '员工管理', component: () => import('../views/deptManage/staffManage.vue')}
  ]
}

export default route



// WEBPACK FOOTER //
// ./src/router/hospitalManageRouter.js